import { createContext, useContext } from "@wordpress/element";

const ScanContext = createContext();

export const useScan = () => {
	const ctx = useContext(ScanContext);
	if (!ctx) throw new Error("useScan must be used within ScanContextProvider");
	return ctx;
};

export default ScanContext;
